export const URL_BEFORE_LOGGED_OUT_CREATED = 'url_before_logging_out_created';
export const URL_BEFORE_LOGGED_OUT_DELETED = 'url_before_logging_out_deleted';

export const URL_BEFORE_API_WENT_DOWN_CREATED = 'url_before_api_went_down_created';
export const URL_BEFORE_API_WENT_DOWN_DELETED = 'url_before_api_went_down_deleted';
